export default "__VITE_ASSET__3ddeb148__"